class ThemeStrategy {
  getPlatformCode() {
    throw new Error(`${this.constructor.name}.getPlatformCode() must be implemented`);
  }

  getPalette() {
    throw new Error(`${this.constructor.name}.getPalette() must be implemented`);
  }

  getComponents() {
    throw new Error(`${this.constructor.name}.getComponents() must be implemented`);
  }

  getTypography() {
    throw new Error(`${this.constructor.name}.getTypography() must be implemented`);
  }

  getBranding() {
    throw new Error(`${this.constructor.name}.getBranding() must be implemented`);
  }
}

export default ThemeStrategy;
